export default __webpack_public_path__ + "static/media/web-development.f3749c4c.svg";